import LogoKS from "./logo/logo_khoufstudio.svg"
import BackgroundLP from "./images/background_landingpage.png"
import BackgroundLP2 from "./images/images background.svg"

export { LogoKS, BackgroundLP, BackgroundLP2 }
